import { InputAdornment, styled, TextField } from '@mui/material';
import { parseNumericInput } from 'helpers/UIHelpers';
import NumberFormatCustom from 'components/NumberFormat/NumberFormatCustom';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';

const StyTextField = styled(TextField)(() => ({
    '& .MuiInputBase-root': {
        backgroundColor: 'white',
    },
    '& .Mui-disabled': {
        color: 'black', // text color
        backgroundColor: 'transparent',
    },
    width: '100%',
    height: '100%',
}));
const MinMaxSelect = ({
    minValue,
    setMinValue,
    maxValue,
    setMaxValue,
}: {
    minValue: number | undefined;
    setMinValue: (value: number | undefined) => void;
    maxValue: number | undefined;
    setMaxValue: (value: number | undefined) => void;
}): React.ReactElement => {
    const { t } = useTranslation();
    const handleChange =
        (setter: (value: number | undefined) => void) =>
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const newValue = parseNumericInput(event.target.value);
            setter(newValue === '' ? undefined : newValue);
        };
    return (
        <Flex gap={3}>
            <StyTextField
                variant="outlined"
                value={minValue}
                label={t(
                    'humanResources.simulation.freeHypothesis.ifse.minValue',
                )}
                onChange={handleChange(setMinValue)}
                sx={{
                    flex: 1,
                }}
                InputProps={{
                    inputComponent: NumberFormatCustom,
                    startAdornment: (
                        <InputAdornment position="start">€</InputAdornment>
                    ),
                }}
                required
            />
            <StyTextField
                variant="outlined"
                value={maxValue}
                label={t(
                    'humanResources.simulation.freeHypothesis.ifse.maxValue',
                )}
                onChange={handleChange(setMaxValue)}
                sx={{
                    flex: 1,
                    appearance: 'textField',
                }}
                InputProps={{
                    inputComponent: NumberFormatCustom,
                    startAdornment: (
                        <InputAdornment position="start">€</InputAdornment>
                    ),
                }}
                required
            />
        </Flex>
    );
};
export default MinMaxSelect;
